import {loadLib} from "../../../utils/loadLib";

let isLoaded = false;
let loadingPromise = null;

function hasOrderOnPage() {
	return Boolean(document.querySelector('#form-cart'));
}

function loadOrderModule() {
	if (isLoaded) {
		return Promise.resolve();
	}

	if (!loadingPromise) {
		loadingPromise = loadLib.catalogOrder().then((m) => {
			if (typeof m?.init === 'function') {
				m.init();
			}
			isLoaded = true;
		});
	}

	return loadingPromise;
}

function initCatalogOrder() {
	if (!hasOrderOnPage()) {
		return;
	}

	loadOrderModule();
}

initCatalogOrder();
document.addEventListener('DOMContentLoaded', initCatalogOrder);
typeof onTurboRender !== 'undefined' && onTurboRender(() => initCatalogOrder());
